var MetadataModules;
(function (MetadataModules) {
    MetadataModules["CINE"] = "cineModule";
    MetadataModules["IMAGE_URL"] = "imageUrlModule";
    MetadataModules["GENERAL_SERIES"] = "generalSeriesModule";
    MetadataModules["PATIENT_STUDY"] = "patientStudyModule";
    MetadataModules["NM_MULTIFRAME_GEOMETRY"] = "nmMultiframeGeometryModule";
    MetadataModules["IMAGE_PLANE"] = "imagePlaneModule";
    MetadataModules["IMAGE_PIXEL"] = "imagePixelModule";
    MetadataModules["MULTIFRAME"] = "multiframeModule";
})(MetadataModules || (MetadataModules = {}));
export default MetadataModules;
//# sourceMappingURL=MetadataModules.js.map